export default __webpack_public_path__ + "static/media/icon-4.2fa0f9c2.svg";